var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"not-found"},[_c('title-bar',{attrs:{"needBack":true,"title":"404"}}),_c('rich-result-page',{attrs:{"type":"lost"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }